export default __webpack_public_path__ + "static/kontaktbild-cbd14c05e75c8819bcbc36f0c21e22f3.jpg";